export const filterRunningClubOfuser = (runnigsClubs, userId) => {
  return runnigsClubs.filter((runningClub) => {
    if (!runningClub?.members || runningClub?.members.length === 0)
      return false;

    const isUserMember = runningClub?.members.some(
      (member) => member?.userId === userId
    );
    // console.log("Es miembro", isUserMember);

    return isUserMember;
  });
};

export const filterRunningClubDontUser = (runnigsClubs, userId) => {
  return runnigsClubs.filter((runningClub) => {
    if (!runningClub?.members || runningClub?.members.length === 0) return true;

    const isUserMember = runningClub?.members.some(
      (member) => member?.userId === userId
    );
    // console.log("Es miembro", isUserMember);

    return !isUserMember;
  });
};
